import RankSeventeen from '@assets/icons/rank-seventeen.svg'
import { Icon } from './Icon'

export const RankSeventeenIcon = Icon(RankSeventeen)
